import { createContext, useContext } from 'react';
import { DbUser } from '../types/user';

export interface UserDndContextValue {
    draggedUser: DbUser | null;
    refreshToken: number;
    onDragStart: (user: DbUser) => void;
    onDragEnd: () => void;
    onDrop: (nodeId: number, nodeName: string) => void;
}

export const UserDndContext = createContext<UserDndContextValue | null>(null);

export function useUserDnd(): UserDndContextValue | null {
    return useContext(UserDndContext);
}
